module.exports = __webpack_public_path__ + "img/oldForest-3018-09-28.cf75ea1a.jpg";